import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'
import { ZHsmKeyTypeMapping } from '../types'

const ZHsmKeyTypeMappingObj = z.object({
  total_count: z.number(),
  list: z.array(ZHsmKeyTypeMapping)
})

const ZApiResponse = z.object({
  http_status: z.number(),
  error: z.boolean(),
  data: z.optional(ZHsmKeyTypeMappingObj)
})

export type HsmKeyTypeMappingObj = z.infer<typeof ZHsmKeyTypeMappingObj>
export type ApiResponse = z.infer<typeof ZApiResponse>

export async function getInactiveKeyTypeMappingsList (
  page: number,
  size: number,
  sortdir: string,
  sortfield: string,
  input: string,
  onSuccess: (hsmKeyTypeMappingObj: HsmKeyTypeMappingObj, httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any
): Promise<void> {
  let field = sortfield
  if (field === 'tenant') {
    field = 'tenant'
  } else if (field === 'key type') {
    field = 'keyTypeName'
  } else if (field === 'label of hybrid kek') {
    field = 'hybridKek'
  } else if (field === 'created At') {
    field = 'createdAt'
  } else if (field === 'created By') {
    field = 'createdBy'
  } else if (field === 'deactivation date') {
    field = 'deactivatedAt'
  } else if (field === 'deactivated By') {
    field = 'deactivatedBy'
  }
  const url = `/app-config-service/api/v1/crypto/inactive/key-mappings?page=${page}&size=${size}&sort=${field},${sortdir}&input=${input}`
  interceptedAxios
    .get(url)
    .then((response) => {
      const parseResponse = ZApiResponse.safeParse(response.data)
      // istanbul ignore next
      if (parseResponse.success) {
        if (parseResponse.data.data !== undefined) {
          onSuccess(parseResponse.data.data, parseResponse.data.http_status)
        } else {
          onFailure({ totalCount: 0, list: [] }, response.status)
        }
      } else {
        onFailure(parseResponse.error.message, response.status)
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        // istanbul ignore next
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message, error.response.status)
        } else {
          onFailure(error.response.statusText, error.response.status)
        }
      } else {
        onFailure('Network Failure', error.status)
      }
    })
}
